import cx from 'classnames'
import { useRef, useState } from 'react'

import { useClickOutside } from '../../../../hooks'

import { Chevron } from './chevron'
import styles from './select.module.css'

interface SelectProps{
  onChange: (id: string | number | null) => void
  options: Array<string | number> | undefined
  value?: string | number | null
  placeholder: string
}

export function Select ({ onChange, options, value, placeholder }: SelectProps): JSX.Element | null {
  let [ open, setOpen ] = useState(false)
  let selectRef = useRef(null)

  useClickOutside(selectRef, () => {
    setOpen(false)
  })

  function handleClick (id: string | number | null): () => void {
    return () => {
      setOpen(false)
      onChange(id)
    }
  }

  if (!options) {
    return null
  }

  let selected = options.find((opt) => opt === value)

  return (
    <div
      className={styles.selectWrapper}
      ref={selectRef}
    >
      <button
        onClick={() => setOpen(!open)}
        className={styles.select}
      >
        <p className={cx({ [styles.placeholder as string]: !selected })}>
          {selected ?? placeholder}
        </p>
        <div style={{ width: '20px', height: '20px' }}><Chevron /></div>
      </button>
      {open && (
        <div className={styles.selectOptionsWrapper}>
          <button
            onClick={handleClick(null)}
            className={styles.selectOption}
          >
            <p>All</p>
          </button>
          {options.map(value => (
            <button
              key={value}
              onClick={handleClick(value)}
              className={styles.selectOption}
            >
              <p>{value}</p>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
